<div>
    <app-header></app-header>
    <div class="container-fluid finzy-font-color">
        <div class="finzyfont">
            <app-investormenu></app-investormenu>
            <div class="col-md-9 col-md-offset-1">
                <div class="row">
                    <p class="breadcrumbs-finzy"><a class="bread" [routerLink]="['/investments']">Investments</a>&nbsp;/
                        Delayed Loan</p>
                </div>
                <div class="row">
                    <div class="row">
                        <h3 class="text-center margin-bottom-20">
                            Hi {{name | titlecase}}, here are your delayed loans
                        </h3>
                    </div>
                    <div class="row center-align margin-bottom-20">
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-xs-6 col-md-3 center-align">
                                    <app-horizontal-loader *ngIf="networkCallInProgress"></app-horizontal-loader>
                                    <span class="big-number text-color-finzy-blue"
                                          *ngIf="metrics">{{metrics.numberOfLoansInvestedIn}}</span>
                                    <span class="sub-text finzy-padding-left-0">
                                    Total loans invested in
                                </span>
                                </div>
                                <div class="col-xs-6 col-md-3 center-align">
                                    <app-horizontal-loader *ngIf="networkCallInProgress"></app-horizontal-loader>
                                    <span class="big-number text-color-finzy-blue"
                                          *ngIf="metrics">{{npaLoans?.length}}</span>
                                    <span class="sub-text finzy-padding-left-0">
                                    Loans with >90 days delay
                                </span>
                                </div>
                                <div class="col-xs-6 col-md-3 center-align">
                                    <app-horizontal-loader *ngIf="networkCallInProgress"></app-horizontal-loader>
                                    <span class="big-number text-color-finzy-blue"
                                          *ngIf="metrics">{{nonNpaDelayedLoans?.length}}</span>
                                    <span class="sub-text finzy-padding-left-0">
                                    Loans with <90 days delay
                                </span>
                                </div>
                                <div class="col-xs-6 col-md-3 center-align">
                                    <app-horizontal-loader *ngIf="networkCallInProgress"></app-horizontal-loader>
                                    <span class="big-number text-color-finzy-blue"
                                          *ngIf="metrics">{{metrics.numberOfWrittenOffLoans}}</span>
                                    <span class="sub-text finzy-padding-left-0">
                                    Loans currently written off
                                </span>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div>
                        <mat-tab-group [selectedIndex]="selectedTabIndex">
                            <mat-tab label="Delays > 90 days (NPA) ({{npaLoans?.length}})">
                                <ng-template matTabContent>
                                    <div class="center-align margin-top-20 margin-bottom-20"
                                         *ngIf="networkCallInProgress">
                                        <mat-spinner [diameter]="35"></mat-spinner>
                                    </div>
                                    <app-loan-list *ngIf="npaLoans"
                                                   [loans]="npaLoans"
                                                   [lenderId]="lenderId"
                                                   [portfolios]="portfolios"
                                    >
                                    </app-loan-list>

                                    <div class="information center-align margin-bottom-20" *ngIf="npaLoans?.length > 0">
                                        <p>
                                            Hi {{name | titlecase}}, In cases where the EMI’s remain unpaid and overdue
                                            for 3 EMI cycles,
                                            we classify the asset as a Non Performing Asset (NPA). However, our teams
                                            continue to follow up
                                            with the borrower and also follow legal recourse available to us as per
                                            regulations to
                                            regularise these loans. If you require more information, please contact
                                            <a class="link" href="mailto:support@finzy.com">support@finzy.com</a>.
                                        </p>
                                    </div>

                                    <div class="text-center margin-top-20"
                                         *ngIf="!networkCallInProgress && npaLoans?.length === 0">
                                        <p>None of your investments have been classified as a Non-Performing Asset</p>
                                        <button mat-flat-button class="primary" type="button"
                                                [routerLink]="['/investordashboard']">
                                            BACK TO DASHBOARD
                                        </button>
                                    </div>

                                </ng-template>
                            </mat-tab>
                            <mat-tab label="Delays < 90 days ({{nonNpaDelayedLoans?.length}})">
                                <ng-template matTabContent>
                                    <div class="center-align margin-top-20 margin-bottom-20"
                                         *ngIf="networkCallInProgress">
                                        <mat-spinner [diameter]="35"></mat-spinner>
                                    </div>
                                    <app-loan-list *ngIf="nonNpaDelayedLoans"
                                                   [loans]="nonNpaDelayedLoans"
                                                   [lenderId]="lenderId"
                                                   [portfolios]="portfolios"
                                    ></app-loan-list>
                                    <div class="information center-align margin-bottom-20"
                                         *ngIf="nonNpaDelayedLoans?.length > 0">
                                        <p>
                                            Hi {{name | titlecase}}, finzy will help to regularize your delayed
                                            loans. If you
                                            require
                                            more information, please contact <a class="link"
                                                                                href="mailto:support@finzy.com">support@finzy.com</a>.
                                        </p>
                                    </div>
                                    <div class="text-center margin-top-20"
                                         *ngIf="!networkCallInProgress && nonNpaDelayedLoans?.length === 0">
                                        <p><span>There are no current delays.</span>
                                            <br>None of your investments have any ongoing delays associated with them.
                                        </p>
                                        <button mat-flat-button class="primary" type="button"
                                                [routerLink]="['/investordashboard']">
                                            BACK TO DASHBOARD
                                        </button>
                                    </div>
                                </ng-template>
                            </mat-tab>
                            <mat-tab label="Written off loans ({{metrics?.numberOfWrittenOffLoans}})">
                                <ng-template matTabContent>
                                    <app-lender-write-off-loans></app-lender-write-off-loans>
                                </ng-template>
                            </mat-tab>
                            <mat-tab label="Settled loans ({{metrics?.numberOfSettledLoans}})">
                                <ng-template matTabContent>
                                    <app-lender-settled-loans></app-lender-settled-loans>
                                    <div class="information center-align margin-bottom-20"
                                         *ngIf="metrics?.numberOfSettledLoans > 0">
                                        <p>
                                            Loans where our collections team has collected part or full outstanding
                                            principal as part
                                            of the loan recovery negotiation with the borrower. We agree on a settlement
                                            option after
                                            exhausting all other options of loan regularisation. On settlement, we
                                            attempt to maximise
                                            the upfront lump sum cashflow from borrower and on receipt of settlement
                                            amount the loan is marked as closed.
                                            If you require more information, please contact
                                            <a class="link" href="mailto:support@finzy.com">support@finzy.com</a>.
                                        </p>
                                    </div>
                                </ng-template>
                            </mat-tab>
                            <mat-tab label="Restructured loans ({{metrics?.numberOfRestructuredLoans}})">
                                <ng-template matTabContent>
                                    <app-restructured-loans></app-restructured-loans>
                                    <div class="information center-align margin-bottom-20">
                                        <p>
                                            Restructuring a loan means changing the remaining loan tenure,
                                            outstanding amount, interest rate and/or EMI. Restructuring is offered to
                                            select borrowers after taking into account circumstances such as change in
                                            current income, employment status, effects of economic recession or COVID
                                            situation, post loan sanction. The objective of restructuring is to allow
                                            the borrower to repay his/her commitments after taking into account all
                                            the variables involved. We agree on restructuring as an option after
                                            exhausting all other options of loan regularisation.
                                            If you require more information, please contact
                                            <a class="link" href="mailto:support@finzy.com">support@finzy.com</a>.
                                        </p>
                                    </div>
                                </ng-template>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
